// extracted by mini-css-extract-plugin
export default {"picture":"Picture_picture__hh1i5"};